import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  signal
} from '@angular/core';
import { LMFacadeService } from '@app/components';
import { LMContextService } from '@app/services';

@Component({
  selector:    'lm-facade-tile',
  standalone: false,
  templateUrl: './lm-facade-tile.component.html',
  styleUrl: './lm-facade-tile.component.scss',
})
export class LMFacadeTileComponent implements OnInit {

  initials = signal('');
  color = signal('');
  showTransactionIcon = signal(false);
  showColumnarIcon = signal(false);
  showAnalyticsIcon = signal(false);
  showMyReportIcon = signal(false);
  showArchiveIcon = signal(false);
  showAsOfDateIcon = signal(false);
  showAuditIcon = signal(false);
  showSharingTag = signal(false);
  sharingTooltip = signal('');

  @Input() title: string | undefined;
  @Input() icon: string | undefined;
  @Input() showIcon: boolean | undefined;
  @Input() description: string | undefined;
  @Input() category: string | undefined;
  @Input() subCategory: string | undefined;
  @Input() owner: string | undefined;
  @Input() businessObject: LMBusinessObject | undefined;
  @Input() template: LMFacadeReportTemplate | undefined;
  @Input() selected = false;
  @HostBinding('style.width.px') @Input() cardWidth: number;

  @Output() businessObjectClicked: EventEmitter<LMBusinessObject> = new EventEmitter<LMBusinessObject>();
  @Output() templateClicked: EventEmitter<LMFacadeReportTemplate> = new EventEmitter<LMFacadeReportTemplate>();

  private readonly actorId: string;

  constructor(
    private lmFacadeService: LMFacadeService,
    private lmContextService: LMContextService,
  ) {
    this.actorId = this.lmContextService.getActorId();
  }

  ngOnInit(): void {
    if (this.template) {
      if (this.template.archive) {
        this.showArchiveIcon.set(true);
      }
      if (this.template.asOfDate) {
        this.showAsOfDateIcon.set(true);
      }
      if (this.template.audit) {
        this.showAuditIcon.set(true);
      }

      if (this.template.owner === this.actorId) {
        this.showMyReportIcon.set(true);
      }

      if (this.template.sharingTooltip && this.template.sharingTooltip !== '' && this.template.sharingTooltip !== this.actorId) {
        this.showSharingTag.set(true);
        this.sharingTooltip.set(this.template.sharingTooltip);
      }
    }
    if (this.businessObject && this.businessObject.moduleTag !== '_start_') {
      this.color.set(this.lmFacadeService.getModuleColor(this.businessObject.moduleTag));
    }
  }

  onBusinessObjectClicked(bo: LMBusinessObject) {
    this.businessObjectClicked.emit(bo);
  }

  onTemplateClicked(template: LMFacadeReportTemplate) {
    this.templateClicked.emit(template);
  }
}
